import React from 'react';

export default ({ message }: { message: string }) => <div className="no-match">{message}</div>;
